import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTreeMapInfo = async (urlDataAPI: any) => {
    const { exportType, type, hubIds, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.laborDemandPulse.exportTreeMapInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, type, hubIds, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
